import React from 'react';
import { useGetSharedVideoDataQuery } from '../../api/projectsApi';
import Icon from '../../components/Icon/Icon';
import { IconColorE, IconSizeE } from '../../models/enums';
import { P, Span } from '../../components/Text/Text';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../utils/constants';
import ReactPlayer from 'react-player';

import styles from './shareVideo.module.scss';

const ShareVideo = () => {
    const token = window.location.pathname.split('/')[3]
    const { data: videoData, isFetching } = useGetSharedVideoDataQuery({ token }, { skip: !token });

    return (
        <main>
            {isFetching ? (
                <div className={styles.loadingWrapper}>
                    <Icon name='loading' size={IconSizeE.S} color={IconColorE.GRAY} />
                </div>
            ) : videoData ? (
                <div className={styles.wrapper}>
                    <h1>{videoData.ProjectName}</h1>
                    <div>
                        {/*@ts-ignore*/}
                        <ReactPlayer
                            url={videoData.DesktopPlaybackUrl}
                            playing
                            controls
                            width='100%'
                            height='100%'
                        />
                    </div>
                    <ul className={styles.infoList}>
                        <li><Span>Project/campaign name</Span>: {videoData.ProjectName}</li>
                        <li><Span>Version name</Span>: {videoData.VersionName}</li>
                        <li><Span>Creation date & time</Span>: {dayjs(videoData.CreationDateTime).format(`${DATE_FORMAT} HH:mm:ss`)}</li>
                        <li><Span>Brand</Span>: {videoData.BrandName}</li>
                        <li><Span>Advertiser</Span>: {videoData.AdvertiserName}</li>
                        <li><Span>Post/sound production</Span>: {videoData.PostProductionCompanyName}</li>
                        <li><Span>Production company</Span>: {videoData.SupplierName}</li>
                        <li><Span>Production location</Span>: {videoData.ProductionLocationIsrael ? 'Local' : 'Abroad'}</li>
                        <li><Span>Speaker names</Span>: {videoData.SpeakerNames}</li>
                        <li><Span>Participants</Span>: {videoData.ParticipantNames}</li>
                    </ul>
                </div>
            ) : (
                <div className={styles.errorWrapper}>
                    <P>Can't upload video data</P>
                </div>
            )}
        </main>
    );
};

export default ShareVideo;